import { ModelTransformer } from '../../../common/common.model';
// import {OaPeopleSort} from './sorting.model';

export interface FractionColours {
    backgroundColour?: string;
    numeratorColour?: string;
    denominatorColour?: string;
}
export class FLMI2Person {
    userId?: number;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    mi2Score?: number;
    totalDirectReports?: number;
    coachedOpportunities?: number;
    expectedOpportunities?: number;
    uncoachedOpportunities?: number;
    totalImproving?: number;
    totalDeclining?: number;
    totalNoScore?: number;
    thresholdColor?: string;
    rosterSize?: number;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedNonOpportunities?: number;
    missedOpportunities?: number;
    nonKpiCoaching?: number;
    missedOpportunity?: number;
    peopleWithOpportunity?: number;
    totalPeople?: number;
    bottomRole?: boolean;
    fundedCoached?: number;
    fundedUncoached?: number;

    managerFullName?: string;
    managerId?: number;
    daysInSupergroup?: number;
    supergroupId?: number;
    supergroup?: string;
    role?: string;
    roleId?: number;

    // calculated
    percentCoached?: number;
    percentUncoached?: number;

    // for team
    startedLate?: boolean;
    leftEarly?: boolean;
    startDate?: Date;
    endDate?: Date;
    isSubordinate?: boolean;
    isTop?: boolean;
    isShowingExpandMenu?: boolean;
    maxCoached?: number;
    maxUncoached?: number;
    maxExpectedOpportunities?: number;

    // for higer level mgr
    subOrdinates?: FLMI2Person[];
    metrics?: FLMI2Person[];
    FlMi2Details?: any;
    isExpanded?: boolean = false;
    isExpandedMetrics?: boolean = false;

    constructor(init?: Partial<FLMI2Person>) {
        Object.assign(this, init);

        const t = Number(this.userId);
        const x = Number(this.mi2Score);

        if (typeof t !== 'number' || typeof x !== 'number') {
            console.error('Invalid FLMI2Person.', this);
        }
    }
}

export class FLMi2Metric {
    managerId?: number;
    metricId?: number;
    metricInitials?: string;
    metricShortName?: string;
    metricName?: string;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedOpportunities?: number;
    missedOpportunities?: number;

    // calc
    uncoachedOpportunities?: number;
    metricBarMaxWidth?: number;
    topOpps?: number;
}

export class ExtFLMI2Person {
    userId?: number;
    firstName?: string;
    lastName?: string;
    oaScore?: number;
    coachedOpportunities?: number;
    expectedOpportunities?: number;
    uncoachedOpportunities?: number;

    oaThresholdColour?: string;
    rosterSize?: number;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedNonOpportunities?: number;
    missedOpportunities?: number;
    nonKpiCoaching?: number;
    missedOpportunity?: number;
    peopleWithOpportunity?: number;
    totalPeople?: number;
    bottomRole?: number;
    fundedCoached?: number;
    fundedUncoached?: number;

    startedLate?: boolean;
    leftEarly?: boolean;
    startDate?: Date;
    endDate?: Date;
}

export class ExtFLMI2PersonTeam {
    userId?: number;
    firstName?: string;
    lastName?: string;
    mi2Score?: number;
    coachedOpportunities?: number;
    expectedOpportunities?: number;
    uncoachedOpportunities?: number;

    startedLate?: number;
    leftEarly?: number;
    startDate?: Date;
    endDate?: Date;

    oaThresholdColour?: string;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedNonOpportunities?: number;
    missedOpportunities?: number;
    nonKpiCoaching?: number;
    missedOpportunity?: number;
    peopleWithOpportunity?: number;
    totalPeople?: number;
    bottomRole?: number;
    fundedCoached?: number;
    fundedUncoached?: number;
    managerFirstName?: string;
    managerLastName?: string;
    managerFullName?: string;
    managerId?: number;
    daysInSupergroup?: number;
    supergroupId?: number;
    supergroup?: string;
    role?: string;
    roleId?: number;
}

export class ExtFLMi2Metric {
    managerId?: number;
    metricId?: number;
    metricInitials?: string;
    metricShortName?: string;
    metricName?: string;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedOpportunities?: number;
    missedOpportunities?: number;
}

export class FLMi2Transformer
    implements ModelTransformer<FLMI2Person, ExtFLMI2Person>
{
    transform(model: ExtFLMI2Person): FLMI2Person {
        if (model.userId === null) return null;

        const oaperson = new FLMI2Person({
            ...model,
            mi2Score:
                model.oaScore != null ? Math.round(model.oaScore * 100) : null,
            fullName: `${model.firstName} ${model.lastName}`,
            uncoachedOpportunities:
                model.expectedOpportunities - model.coachedOpportunities,
            bottomRole: model.bottomRole === 1,
            isTop: true,
        });

        if (oaperson.expectedOpportunities != null) {
            oaperson.percentCoached =
                oaperson.fundedCoached / oaperson.expectedOpportunities;
            oaperson.percentUncoached =
                oaperson.fundedUncoached / oaperson.expectedOpportunities;
        } else {
            oaperson.percentCoached = 0;
            oaperson.percentUncoached = 0;
        }

        return oaperson;
    }
}

export class FLMi2MetricTransformer
    implements ModelTransformer<FLMi2Metric[], ExtFLMi2Metric[]>
{
    transform(model: ExtFLMi2Metric[]): FLMi2Metric[] {
        const metrics: FLMi2Metric[] = [];
        let topOpps: number = 0;

        if (!model || !model.length) {
            console.error('No FLOA Metrics');
            return;
        }

        // model.sort(OaPeopleSort.sortFLOAMetrics());

        model.forEach((g) => {
            const f: FLMi2Metric = { ...g };

            if (g?.opportunityCount) {
                f.uncoachedOpportunities =
                    g.opportunityCount -
                    (g.coachedOpportunities != null
                        ? g.coachedOpportunities
                        : 0);
            }

            metrics.push(f);
        });

        topOpps = model[0].opportunityCount;

        metrics.forEach((y: FLMi2Metric) => {
            y.topOpps = topOpps;

            if (y.opportunityCount != null) {
                y.metricBarMaxWidth = (y.opportunityCount / topOpps) * 100;
            } else {
                y.metricBarMaxWidth = 0;
            }
        });

        return metrics;
    }
}

function flattenObj<T, U = T>(obj: T, key: string): U[] {
    const flat = [];
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj[key]?.forEach((e) => {
            flat.push(e);
            flat.push(...flattenObj(e, key));
        });
    }
    return flat;
}

export class FLMi2TeamTransformer
    implements ModelTransformer<FLMI2Person[], ExtFLMI2PersonTeam[]>
{
    private readonly _leaders: FLMI2Person[];

    constructor(leader?: FLMI2Person) {
        this._leaders = leader ? flattenObj(leader, 'subOrdinates') : [];
        leader && this._leaders.unshift(leader);
    }

    transform(model: ExtFLMI2PersonTeam[]): FLMI2Person[] {
        const flmi2: FLMI2Person[] = [];

        model.forEach((g) => {
            const s: FLMI2Person = {
                ...g,
                fullName: `${g.firstName} ${g.lastName}`,
                uncoachedOpportunities:
                    g.expectedOpportunities - g.coachedOpportunities,
                bottomRole: g.bottomRole === 1,
                startedLate: g.startedLate === 1,
                leftEarly: g.leftEarly === 1,
                isSubordinate: true,
                isExpanded: false,
                isExpandedMetrics: false,
                isShowingExpandMenu: false,
                isTop: false,
                managerFullName: `${g.managerFirstName} ${g.managerLastName}`,
            };

            // percentage relative to manager's Funded Opportunities
            const leader = this._leaders.find((e) => e.userId === s.managerId);
            if (leader) {
                s.percentCoached = s.totalImproving / leader.totalImproving;
                s.percentUncoached = s.totalDeclining / leader.totalDeclining;

                s.maxCoached = leader.totalImproving;
                s.maxUncoached = leader.totalDeclining;
                s.maxExpectedOpportunities = leader.totalDirectReports;
            }

            flmi2.push(s);
        });

        return flmi2;
    }
}
